import * as React from 'react';
export const benefitpaySvg = React.forwardRef(function benefitpaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.963 2.812C14.768 1.235 13.338.154 11.84.007 9.271.002 4.134 0 4.134 0L1 14.62l3.502-2.14.695-3.41s4.676.054 5.052-.116c.556-.249 2.462-1.418 2.827-1.707 1.322-1.046 2.104-2.63 1.888-4.435Zm-3.18 1.549c-.29 1.395-1.334 1.821-2.55 1.929-1.163.102-3.455-.003-3.455-.003l.73-3.54s2.126-.002 3.131 0c1.08-.006 2.555.116 2.146 1.614h-.001Zm2.342 4.619a3.152 3.152 0 0 0-.336-.81l-2.624 1.618s.06.35.04.538c.058 1.282-.817 2.452-2.204 2.736-1.387.285-3.428.145-3.428.145l-4.463 2.74s6.958.191 8.532-.153c2.869-.671 5.35-3.772 4.483-6.814Z',
    }),
  );
});
benefitpaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var benefitpay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'benefitpay',
  svg: benefitpaySvg,
};
